import template from './leave_taken_by_leave_type_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class LeaveTakenByLeaveTypeHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveTakenByLeaveTypeHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveTakenByLeaveTypeHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveTakenByLeaveTypeHelp',
	dialog_class: LeaveTakenByLeaveTypeHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_taken_by_leave_type_help',
	provider: 'ps'
};
